import React, { useEffect, useState } from "react";
import styled from "styled-components";
import variables from "../../constants/assets/variables";
import FileUpload from "../../components/Common/FileUpload";
import { useHistory } from "react-router-dom";
import Errors from "../../constants/Errors.json";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as BulkRequestDriverInformationActions from "../../store/actions/BulkRequestDriverInformation";
import * as UserActions from "../../store/actions/User";

import NoFooterModal from "../../components/Common/NoFooterModal";
import Button from "sushiweb/Button";
import InformationBar from "../../components/Common/InformationBar";

import {
  BottomSectionModal,
  UploadCsvOption,
  NotesSection,
} from "../../constants/assets/containers";
import PaginatedReactDropdown from "../../components/Common/PaginatedReactDropdown";
import MenuActionsMappings from "../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../constants/Menu/MenuNames.json";

const options = [
  {
    dropdownOpts: [
      "CONTACT_INFO",
      "LEAD_PHONE_NO_INFO_V2"
    ],
    permission: MenuActionsMappings[MenuNames.DRIVER_INFO_BULK_REQUEST].REQUEST_CONTACT_INFO,
  },
  {
    dropdownOpts: [
      "VEHICLE_INFO",
      "ADDRESS_INFO",
      "FINANCIAL_INFO",
    ],
    permission: MenuActionsMappings[MenuNames.DRIVER_INFO_BULK_REQUEST].REQUEST_PERSONAL_INFO,
  }
]

const BulkRequestDriverInformation = ({ allMenuActions, bulkUploadDetails, setStatus }) => {
  const history = useHistory();
  const [activeFile, setActiveFile] = useState("");
  const [callback_key, setCallback_key] = useState("");
  const [presign_url, setPresign_url] = useState("");
  const [filePath, setFilePath] = useState("");
  const [requestType, setRequestType] = useState("");
  const [requestOptions, setRequestOptions] = useState([]);
  const sample_download_url = `${
    process.env.REACT_APP_API_URL
      ? `${process.env.REACT_APP_API_URL.replace(
          variables.routeEndpoint,
          variables.sampleFileEndPoint
        )}${sampleFileName(requestType)}`
      : ""
  }`;

  const instructions = [
    "Please provide data as per the format in the sample file.",
    "Please try to open your sample csv file always with MS excel or google sheets but don't open with other editors.",
  ];

  const handleClose = () => {
    history.push("/");
  };

  const handleChange = (key, val) => {
    setRequestType(val);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!activeFile && !requestType) {
      return;
    }
    bulkUploadDetails({
      file_name: "rider_details",
      type: requestType,
    }).then((res) => {
      if (res) {
        setFilePath(res.file_path);
        setCallback_key(res.callback_key);
        setPresign_url(res.file_upload_url);
      } else {
        setStatus({ type: "error", message: Errors.GENERAL_ERROR });
      }
    });
  };

  const handleButtonDisabled = () => {
    return !(activeFile !== "" && requestType !== "");
  };

  const handleFileChange = (file) => {
    setActiveFile(file);
  };

  useEffect(() => {
    let reqOptions = [];
    options.forEach((option) => {
      const permission = option.permission;
      if (allMenuActions && allMenuActions[permission]) {
        reqOptions.push(...option.dropdownOpts);
      }
    });
    setRequestOptions(reqOptions);
  }, [allMenuActions]);

  return (
    <BulkUploadRolesModalContainer>
      <NoFooterModal
        header
        heading="Bulk Request Driver Information"
        handleClose={handleClose}
        id="bulkRequestDriverInformation"
        modalButtons={
          <BottomSectionModal>
            <Button
              data-testid="uploadRiderDetails"
              disabled={handleButtonDisabled()}
              onClick={handleSubmit}
              className="sushi-btn"
            >
              Confirm
            </Button>
          </BottomSectionModal>
        }
      >
        <PaginatedReactDropdown
          options={requestOptions}
          handleChange={handleChange}
          keyToChange="requestType"
          placeholder="Request type"
          showCross={true}
          id="bulkRequestDriverInformationFileType"
          showPagination={false}
          value={requestType}
          labelWidth="15%"
        />
        <UploadCsvOption>
          <FileUpload
            title="CSV"
            uploadUrl="/personal-info/request/ack"
            callback_key={callback_key}
            presign_url={presign_url}
            handleClose={handleClose}
            keyName="callback_key"
            activeFile={activeFile}
            setActiveFile={handleFileChange}
            extraParamsAckObj={{
              file_path: filePath,
              type: requestType,
              presign_url: presign_url,
            }}
            acceptTypes=".csv, .xls, .xlsx"
            maxSize={0.5}
          />
        </UploadCsvOption>
        <NotesSection>
          <InformationBar
            sampleUrl={sample_download_url}
            instructions={instructions}
          />
        </NotesSection>
      </NoFooterModal>
    </BulkUploadRolesModalContainer>
  );
};

const sampleFileName = (requestType) => {
  switch (requestType) {
    case "CONTACT_INFO":
    case "VEHICLE_INFO":
      return "/sample/bulk_driver_info_request.csv";
    case "LEAD_PHONE_NO_INFO_V2":
      return "/sample/bulk_lead_phone_no_info_request_with_id_v2.csv";
    default:
      return "/sample/bulk_driver_info_request_with_id.csv";
  }
};

const BulkUploadRolesModalContainer = styled.section``;

function mapStateToProps(state) {
  const { MenuActions } = state;
  return {
    allMenuActions: MenuActions.allMenuActions,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    bulkUploadDetails: bindActionCreators(
      BulkRequestDriverInformationActions.getUploadUrl,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(BulkRequestDriverInformation);
